module.exports = __webpack_public_path__ + "img/loader.1cc214f6.svg";